var chunkMapping = {
	"16": [
		91016
	],
	"90": [
		4090
	],
	"198": [
		39198
	],
	"287": [
		4287
	],
	"309": [
		62309
	],
	"346": [
		26346
	],
	"363": [
		67363
	],
	"368": [
		31368
	],
	"387": [
		49387
	],
	"391": [
		9391
	],
	"402": [
		54402
	],
	"435": [
		435
	],
	"437": [
		76437
	],
	"460": [
		26460
	],
	"488": [
		5488
	],
	"497": [
		21497
	],
	"525": [
		80525
	],
	"579": [
		8579
	],
	"580": [
		91580
	],
	"629": [
		8629
	],
	"647": [
		29647
	],
	"726": [
		79726
	],
	"753": [
		91753
	],
	"810": [
		72810
	],
	"827": [
		29827
	],
	"889": [
		76889
	],
	"952": [
		32952
	],
	"955": [
		47955
	],
	"963": [
		69963
	]
};
var idToExternalAndNameMapping = {
	"435": [
		"default",
		"./Accordion",
		21008
	],
	"4090": [
		"default",
		"./Spinner",
		21008
	],
	"4287": [
		"default",
		"./Autocomplete",
		21008
	],
	"5488": [
		"default",
		"./Checkbox",
		21008
	],
	"8579": [
		"default",
		"./RadioButtons",
		21008
	],
	"8629": [
		"default",
		"./Table",
		21008
	],
	"9391": [
		"default",
		"./Popup",
		21008
	],
	"21497": [
		"default",
		"./Input",
		21008
	],
	"26346": [
		"default",
		"./Buttons",
		21008
	],
	"26460": [
		"default",
		"./Slider",
		21008
	],
	"29647": [
		"default",
		"./Switches",
		21008
	],
	"29827": [
		"default",
		"./CheckboxesDropdown",
		21008
	],
	"31368": [
		"default",
		"./Tooltip",
		21008
	],
	"32952": [
		"default",
		"./Header",
		21008
	],
	"39198": [
		"default",
		"./Footer",
		21008
	],
	"47955": [
		"default",
		"./Dialog",
		21008
	],
	"49387": [
		"default",
		"./Dropdowns",
		21008
	],
	"54402": [
		"default",
		"./locsys/ModelCard",
		21008
	],
	"62309": [
		"default",
		"./ErrorFallback",
		21008
	],
	"67363": [
		"default",
		"./Search",
		21008
	],
	"69963": [
		"default",
		"./Map",
		21008
	],
	"72810": [
		"default",
		"./FileUpload",
		21008
	],
	"76437": [
		"default",
		"./Card",
		21008
	],
	"76889": [
		"default",
		"./Datepicker",
		21008
	],
	"79726": [
		"default",
		"./Plot",
		21008
	],
	"80525": [
		"default",
		"./Form",
		21008
	],
	"91016": [
		"default",
		"./locsys/DslCard",
		21008
	],
	"91580": [
		"default",
		"./Leaderboard",
		21008
	],
	"91753": [
		"default",
		"./Chat",
		21008
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}